<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-post-15-arms-imports-region-box">
  <!-- Artboard: xs -->
  <div
    id="g-post-15-arms-imports-region-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.35483870967742;"
  >
    <div
      id="g-post-15-arms-imports-region-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-15-arms-imports-region-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.3573%;margin-top:-9.6px;left:0.6383%;width:68px;"
    >
      <p class="g-pstyle0">Europe</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.3573%;margin-top:-9.6px;left:53.8466%;width:135px;"
    >
      <p class="g-pstyle0">Asia and Oceania</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.4496%;margin-top:-9.1px;left:0.6383%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.2453%;margin-top:-9.1px;left:0.6383%;width:37px;"
    >
      <p class="g-pstyle1">25</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:31.8367%;margin-top:-9.1px;left:55.3295%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:31.8367%;margin-top:-9.1px;left:88.6933%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:31.8367%;margin-top:-9.1px;left:2.2992%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:31.8367%;margin-top:-9.1px;left:35.663%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:34.6906%;margin-top:-9.6px;left:0.6383%;width:99px;"
    >
      <p class="g-pstyle0">
        Midd<span class="g-cstyle0">l</span>e
        <span class="g-cstyle1">E</span>a<span class="g-cstyle2">s</span>t
      </p>
    </div>
    <div
      id="g-ai0-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:34.6906%;margin-top:-9.6px;left:53.8509%;width:83px;"
    >
      <p class="g-pstyle0">Americas</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:36.7829%;margin-top:-9.1px;left:0.6383%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:49.5786%;margin-top:-9.1px;left:0.6383%;width:37px;"
    >
      <p class="g-pstyle1">25</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:65.17%;margin-top:-9.1px;left:2.2992%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:65.17%;margin-top:-9.1px;left:35.663%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:65.17%;margin-top:-9.1px;left:55.3295%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:65.17%;margin-top:-9.1px;left:88.6933%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:68.0239%;margin-top:-9.6px;left:0.6383%;width:61px;"
    >
      <p class="g-pstyle0">
        <span class="g-cstyle0">A</span><span class="g-cstyle3">f</span>rica
      </p>
    </div>
    <div
      id="g-ai0-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:68.0239%;margin-top:-9.6px;left:53.8453%;width:66px;"
    >
      <p class="g-pstyle0">Others</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:70.1162%;margin-top:-9.1px;left:0.6383%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:82.9119%;margin-top:-9.1px;left:0.6383%;width:37px;"
    >
      <p class="g-pstyle1">25</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:98.5033%;margin-top:-9.1px;left:2.2992%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:98.5033%;margin-top:-9.1px;left:35.663%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:98.5033%;margin-top:-9.1px;left:55.3295%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai0-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:98.5033%;margin-top:-9.1px;left:88.6933%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-post-15-arms-imports-region-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.85;"
  >
    <div
      id="g-post-15-arms-imports-region-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-15-arms-imports-region-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.1038%;margin-top:-9.6px;left:35.5496%;width:135px;"
    >
      <p class="g-pstyle0">Asia and Oceania</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.5135%;margin-top:-9.1px;left:0.7654%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.7704%;margin-top:-9.6px;left:70.1365%;width:99px;"
    >
      <p class="g-pstyle0">
        Midd<span class="g-cstyle0">l</span>e
        <span class="g-cstyle1">E</span>a<span class="g-cstyle2">s</span>t
      </p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:22.5135%;margin-top:-9.1px;left:0.7654%;width:37px;"
    >
      <p class="g-pstyle1">25</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:27.6038%;margin-top:-9.6px;left:1.1957%;width:68px;"
    >
      <p class="g-pstyle0">Europe</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.5135%;margin-top:-9.1px;left:1.84%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.5135%;margin-top:-9.1px;left:23.4283%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.5135%;margin-top:-9.1px;left:36.2337%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.5135%;margin-top:-9.1px;left:57.8221%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.5135%;margin-top:-9.1px;left:70.7018%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.5135%;margin-top:-9.1px;left:92.2901%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:53.5135%;margin-top:-9.1px;left:0.7654%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:73.5135%;margin-top:-9.1px;left:0.7654%;width:37px;"
    >
      <p class="g-pstyle1">25</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:80.7704%;margin-top:-9.6px;left:35.5496%;width:61px;"
    >
      <p class="g-pstyle0">
        <span class="g-cstyle0">A</span><span class="g-cstyle3">f</span>rica
      </p>
    </div>
    <div
      id="g-ai1-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:82.4371%;margin-top:-9.6px;left:1.1959%;width:83px;"
    >
      <p class="g-pstyle0">Americas</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:89.2704%;margin-top:-9.6px;left:69.6272%;width:66px;"
    >
      <p class="g-pstyle0">Others</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.5135%;margin-top:-9.1px;left:1.8788%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.5135%;margin-top:-9.1px;left:23.4671%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.5135%;margin-top:-9.1px;left:36.1924%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.5135%;margin-top:-9.1px;left:57.7807%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.5135%;margin-top:-9.1px;left:70.5869%;width:51px;"
    >
      <p class="g-pstyle1">2010</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:97.5135%;margin-top:-9.1px;left:92.1752%;width:53px;"
    >
      <p class="g-pstyle1">2025</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-post-15-arms-imports-region-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 2.03076923076923;"
  >
    <div
      id="g-post-15-arms-imports-region-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-15-arms-imports-region-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.7428%;margin-top:-10.2px;left:22.7714%;width:143px;"
    >
      <p class="g-pstyle0">Asia and <span class="g-cstyle0">O</span>ceania</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.3326%;margin-top:-9.1px;left:0.0759%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:21.8966%;margin-top:-10.2px;left:42.6286%;width:104px;"
    >
      <p class="g-pstyle0">
        Midd<span class="g-cstyle1">l</span>e
        <span class="g-cstyle2">E</span>a<span class="g-cstyle3">s</span>t
      </p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.1788%;margin-top:-9.1px;left:0.0759%;width:37px;"
    >
      <p class="g-pstyle1">25</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.5889%;margin-top:-10.2px;left:2.9142%;width:71px;"
    >
      <p class="g-pstyle0">Europe</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:62.2043%;margin-top:-10.2px;left:82.3429%;width:63px;"
    >
      <p class="g-pstyle0">
        <span class="g-cstyle1">A</span><span class="g-cstyle4">f</span>rica
      </p>
    </div>
    <div
      id="g-ai2-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:65.2813%;margin-top:-10.2px;left:62.4856%;width:87px;"
    >
      <p class="g-pstyle0">Americas</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:88.0249%;margin-top:-9.1px;left:0.0759%;width:30px;"
    >
      <p class="g-pstyle1">0</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:3.3024%;width:53px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai2-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:14.9569%;width:55px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:23.1507%;width:53px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai2-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:34.8053%;width:55px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:42.9994%;width:53px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai2-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:54.6539%;width:55px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:62.8479%;width:53px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai2-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:74.5024%;width:55px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:82.6963%;width:53px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai2-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.4992%;margin-top:-9.6px;left:94.3509%;width:55px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-post-15-arms-imports-region-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 2.06666666666666;"
  >
    <div
      id="g-post-15-arms-imports-region-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-15-arms-imports-region-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.2771%;margin-top:-11.7px;left:0.5492%;width:57px;"
    >
      <p class="g-pstyle0">50%</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.6104%;margin-top:-11.7px;left:22.9345%;width:158px;"
    >
      <p class="g-pstyle1">Asia and <span class="g-cstyle0">O</span>ceania</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:22.8326%;margin-top:-11.7px;left:42.5202%;width:114px;"
    >
      <p class="g-pstyle1">
        Midd<span class="g-cstyle1">l</span>e
        <span class="g-cstyle2">E</span>a<span class="g-cstyle3">s</span>t
      </p>
    </div>
    <div
      id="g-ai3-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:45.2771%;margin-top:-11.7px;left:0.5495%;width:41px;"
    >
      <p class="g-pstyle0">25</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:58.6104%;margin-top:-11.7px;left:3.349%;width:77px;"
    >
      <p class="g-pstyle1">Europe</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:63.0549%;margin-top:-11.7px;left:81.6913%;width:68px;"
    >
      <p class="g-pstyle1">
        <span class="g-cstyle1">A</span><span class="g-cstyle4">f</span>rica
      </p>
    </div>
    <div
      id="g-ai3-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:66.3882%;margin-top:-11.7px;left:62.1058%;width:95px;"
    >
      <p class="g-pstyle1">Americas</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:87.4993%;margin-top:-11.7px;left:0.5495%;width:33px;"
    >
      <p class="g-pstyle0">0</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:3.7317%;width:59px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai3-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:15.8983%;width:61px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:23.3088%;width:59px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai3-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:35.4754%;width:61px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:42.8859%;width:59px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai3-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:55.0524%;width:61px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:62.4629%;width:59px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai3-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:74.6294%;width:61px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:82.0399%;width:59px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">2</span><span class="g-cstyle1">0</span>10
      </p>
    </div>
    <div
      id="g-ai3-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6104%;margin-top:-11.7px;left:94.2064%;width:61px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">2</span>025</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2026-03-11 20:13 -->

<!-- Generated by ai2html v0.101.0 - 2026-03-11 20:13 -->
<!-- ai file: post-15-arms-imports-region.ai -->
<style lang="scss">
  #g-post-15-arms-imports-region-box,
  #g-post-15-arms-imports-region-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-15-arms-imports-region-box p {
    margin: 0;
  }
  #g-post-15-arms-imports-region-box .g-aiAbs {
    position: absolute;
  }
  #g-post-15-arms-imports-region-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-15-arms-imports-region-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-15-arms-imports-region-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-15-arms-imports-region-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-15-arms-imports-region-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post-15-arms-imports-region-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post-15-arms-imports-region-lg {
        display: block !important;
      }
    }
  }
  #g-post-15-arms-imports-region-xs {
    position: relative;
    overflow: hidden;
  }
  #g-post-15-arms-imports-region-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(166, 166, 166);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-15-arms-imports-region-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    color: rgb(102, 102, 102);
  }
  #g-post-15-arms-imports-region-xs .g-pstyle1 {
    height: 17px;
  }
  #g-post-15-arms-imports-region-xs .g-cstyle0 {
    letter-spacing: -0.004em;
  }
  #g-post-15-arms-imports-region-xs .g-cstyle1 {
    letter-spacing: -0.003em;
  }
  #g-post-15-arms-imports-region-xs .g-cstyle2 {
    letter-spacing: -0.001em;
  }
  #g-post-15-arms-imports-region-xs .g-cstyle3 {
    letter-spacing: -0.007em;
  }
  #g-post-15-arms-imports-region-sm {
    position: relative;
    overflow: hidden;
  }
  #g-post-15-arms-imports-region-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(166, 166, 166);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-15-arms-imports-region-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    color: rgb(102, 102, 102);
  }
  #g-post-15-arms-imports-region-sm .g-pstyle1 {
    height: 17px;
  }
  #g-post-15-arms-imports-region-sm .g-cstyle0 {
    letter-spacing: -0.004em;
  }
  #g-post-15-arms-imports-region-sm .g-cstyle1 {
    letter-spacing: -0.003em;
  }
  #g-post-15-arms-imports-region-sm .g-cstyle2 {
    letter-spacing: -0.001em;
  }
  #g-post-15-arms-imports-region-sm .g-cstyle3 {
    letter-spacing: -0.007em;
  }
  #g-post-15-arms-imports-region-md {
    position: relative;
    overflow: hidden;
  }
  #g-post-15-arms-imports-region-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-15-arms-imports-region-md .g-pstyle0 {
    height: 19px;
  }
  #g-post-15-arms-imports-region-md .g-pstyle1 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(166, 166, 166);
  }
  #g-post-15-arms-imports-region-md .g-pstyle2 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    color: rgb(123, 123, 123);
  }
  #g-post-15-arms-imports-region-md .g-cstyle0 {
    letter-spacing: 0.005em;
  }
  #g-post-15-arms-imports-region-md .g-cstyle1 {
    letter-spacing: -0.004em;
  }
  #g-post-15-arms-imports-region-md .g-cstyle2 {
    letter-spacing: -0.003em;
  }
  #g-post-15-arms-imports-region-md .g-cstyle3 {
    letter-spacing: -0.001em;
  }
  #g-post-15-arms-imports-region-md .g-cstyle4 {
    letter-spacing: -0.007em;
  }
  #g-post-15-arms-imports-region-lg {
    position: relative;
    overflow: hidden;
  }
  #g-post-15-arms-imports-region-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 22px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 18px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-15-arms-imports-region-lg .g-pstyle0 {
    font-weight: 300;
    height: 22px;
    color: rgb(166, 166, 166);
  }
  #g-post-15-arms-imports-region-lg .g-pstyle1 {
    height: 22px;
  }
  #g-post-15-arms-imports-region-lg .g-pstyle2 {
    font-weight: 300;
    height: 22px;
    color: rgb(123, 123, 123);
  }
  #g-post-15-arms-imports-region-lg .g-cstyle0 {
    letter-spacing: 0.005em;
  }
  #g-post-15-arms-imports-region-lg .g-cstyle1 {
    letter-spacing: -0.004em;
  }
  #g-post-15-arms-imports-region-lg .g-cstyle2 {
    letter-spacing: -0.003em;
  }
  #g-post-15-arms-imports-region-lg .g-cstyle3 {
    letter-spacing: -0.001em;
  }
  #g-post-15-arms-imports-region-lg .g-cstyle4 {
    letter-spacing: -0.007em;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
